import Game from './game';

document.addEventListener("DOMContentLoaded", () => {
  const canvasEl = document.getElementsByTagName("canvas")[0];
  canvasEl.width = Game.DIM_X;
  canvasEl.height = Game.DIM_Y;
  const ctx = canvasEl.getContext("2d");

  let game = new Game(ctx);
  game.start();
});



//////////////////
// WEBPACK FOOTER
// ./lib/drmariojs.js
// module id = 1
// module chunks = 0